export default __webpack_public_path__ + "static/media/activity-removebg.1abc8d74.png";